import API from '@/services/api.service'
import widgetOptions from '../helpers/widget-options.js'
const ProductsAPI = {
  getAll () {
    return API.get(`menu_feeds/${widgetOptions.config.feed_id}`).catch(
      error => {
        return Promise.reject(error.response)
        // throw new Error(`API Service ${error}`)
      }
    )
  }
}

export default ProductsAPI
